import React, { useMemo, useState } from 'react'
import { Button, Stack, Tooltip } from '@mui/material'
import { Outlet, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import useSubscribeRefresh from 'use-subscribe-actions'
import MainContent, { TableContent } from 'components-shared'
import EmptyScreen from 'packages/ui/EmptyScreen'
import { useSites, useUser } from 'store'

import Filters from './Filters'
import Table from './Table'
import useRooms from './use-rooms'
import MessageDialog from './MessageDialog'

const StreamCastView = () => {
  const { t } = useTranslation()
  const { rooms, loading, deviceCounts } = useRooms()
  const [messageModalOpen, setMessageModalOpen] = useState(false)
  const navigate = useNavigate()
  const [user] = useUser()
  const messageRoom = useMemo(() => rooms?.[0], [rooms])
  const isEditMessageDisabled = !messageRoom || loading || Boolean(user.demo_mode)

  useSubscribeRefresh(() => navigate('/stream-cast'))

  return (
    <Stack flex={1}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" gap={2}>
        <Filters counts={deviceCounts} />
        <Tooltip title={t('stream-cast.card.edit_tv_message_tooltip')} arrow>
          <span style={{ display: 'inline-flex' }}>
            <Button
              variant="contained"
              size="small"
              disabled={isEditMessageDisabled}
              startIcon={<i className="fa-solid fa-tv" style={{ fontSize: 12 }} />}
              onClick={() => setMessageModalOpen(true)}
              sx={{
                fontSize: 12,
                height: 32,
                whiteSpace: 'nowrap'
              }}>
              {t('stream-cast.card.edit_tv_message')}
            </Button>
          </span>
        </Tooltip>
      </Stack>
      <MainContent>
        <TableContent>
          <Table rooms={rooms} loading={loading} />
        </TableContent>
        <Outlet />
      </MainContent>
      <MessageDialog
        open={messageModalOpen}
        onClose={() => setMessageModalOpen(false)}
        room={messageRoom}
      />
    </Stack>
  )
}

const StreamCast = () => {
  const { t } = useTranslation()
  const [{ selected }] = useSites()
  return selected.length === 1
    ? <StreamCastView />
    : <EmptyScreen>{t('ui_elements.disclaimer_one_site')}</EmptyScreen>
}

export default StreamCast
